import {
  memberBrandAffiliationsResponseSchema,
  orgSelfServiceInvitationCreateResponseSchema,
  type MemberBrandAffiliationsResponse,
  type MyOrganizationResponse,
  type OrgSelfServiceInvitationCreateRequest,
  type OrgSelfServiceInvitationCreateResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

// GET /organizations/me — the caller's own org row. Any authenticated
// member may call it. Needed for `brandCount`: an org-level fact the
// /equipo invite picker gates `brand_manager` on.
export const organizationsApi = {
  me: (): Promise<MyOrganizationResponse> =>
    request<MyOrganizationResponse>("GET", "core", "/organizations/me"),
  // POST /organizations/me/invitations (ADR-0116) — self-service invite
  // into the caller's own org, with per-store asset stamping for
  // store_manager/facility_supervisor. Replaces auth-svc's
  // POST /auth/invitations as the Equipo screen's invite endpoint —
  // this core-api route fans out to that same auth-svc endpoint after
  // applying the recipe/cardinality/containment checks and the asset
  // stamp, so ADR-0112's escalation cap and ADR-0115's multibrand gate
  // stay enforced exactly as before.
  createInvitation: async (
    body: OrgSelfServiceInvitationCreateRequest
  ): Promise<OrgSelfServiceInvitationCreateResponse> => {
    const json = await request<unknown>("POST", "core", "/organizations/me/invitations", {
      body,
    });
    return orgSelfServiceInvitationCreateResponseSchema.parse(json);
  },
  // ADR-0165 — the supervisors' brands of affiliation, for the Equipo
  // roster. Org-scoped roles and platform admins only (403 otherwise).
  listBrandAffiliations: async (): Promise<MemberBrandAffiliationsResponse> => {
    const json = await request<unknown>("GET", "core", "/organizations/me/brand-affiliations");
    return memberBrandAffiliationsResponseSchema.parse(json);
  },
  setBrandAffiliation: (vars: { userId: string; brandId: string }): Promise<unknown> =>
    request<unknown>(
      "PUT",
      "core",
      `/organizations/me/members/${encodeURIComponent(vars.userId)}/brand-affiliation`,
      { body: { brandId: vars.brandId } }
    ),
};
